document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-nav-toggle]');

  if (header && toggle) {
    toggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  const campaignCarousels = [...document.querySelectorAll('.velv-campaign-carousel')];

  const setCampaignCarouselLoopDistance = (carousel) => {
    const group = carousel.querySelector('.velv-campaign-carousel__group');
    const width = Math.round(Math.max(group?.scrollWidth || 0, group?.offsetWidth || 0));

    if (width > 0) {
      carousel.style.setProperty('--carousel-loop-distance', `-${width}px`);
    }
  };

  const mobileCarouselQuery = window.matchMedia('(max-width: 980px)');
  const mobileCarouselLoops = new WeakMap();

  const stopMobileCampaignLoop = (carousel) => {
    const loop = mobileCarouselLoops.get(carousel);

    if (loop?.frame) {
      cancelAnimationFrame(loop.frame);
    }

    mobileCarouselLoops.delete(carousel);
    carousel.classList.remove('is-mobile-carousel-loop');

    const viewport = carousel.querySelector('.velv-campaign-carousel__viewport');
    const track = carousel.querySelector('.velv-campaign-carousel__track');

    if (viewport) viewport.scrollLeft = 0;
    if (track) track.style.removeProperty('transform');

    carousel.querySelectorAll('.velv-campaign-carousel__item').forEach((item) => {
      item.style.removeProperty('transform');
    });
  };

  const startMobileCampaignLoop = (carousel) => {
    const viewport = carousel.querySelector('.velv-campaign-carousel__viewport');
    const track = carousel.querySelector('.velv-campaign-carousel__track');
    const groups = [...carousel.querySelectorAll('.velv-campaign-carousel__group')];
    const items = groups[0]
      ? [...groups[0].querySelectorAll('.velv-campaign-carousel__item')]
      : [];

    if (!viewport || !track || !groups.length || !items.length) {
      return;
    }

    if (!mobileCarouselQuery.matches) {
      stopMobileCampaignLoop(carousel);
      return;
    }

    stopMobileCampaignLoop(carousel);

    const loop = {
      frame: 0,
      lastTime: 0,
      positions: [],
      widths: [],
      speed: 0
    };

    mobileCarouselLoops.set(carousel, loop);
    carousel.classList.add('is-mobile-carousel-loop');

    const measure = () => {
      loop.widths = items.map((item) => item.getBoundingClientRect().width);
      loop.positions = [];
      let nextLeft = 0;

      loop.widths.forEach((width, index) => {
        loop.positions[index] = nextLeft;
        nextLeft += width;
      });

      const sequenceWidth = loop.widths.reduce((total, width) => total + width, 0);

      loop.speed = sequenceWidth / 44000;
      loop.lastTime = 0;
    };

    const move = (now) => {
      if (!mobileCarouselQuery.matches) {
        stopMobileCampaignLoop(carousel);
        return;
      }

      if (loop.lastTime === 0) {
        loop.lastTime = now;
      }

      const elapsed = Math.min(now - loop.lastTime, 64);
      const shift = loop.speed * elapsed;
      loop.lastTime = now;

      for (let index = 0; index < items.length; index += 1) {
        loop.positions[index] -= shift;
      }

      for (let index = 0; index < items.length; index += 1) {
        if (loop.positions[index] + loop.widths[index] <= 0) {
          let furthestRight = 0;

          for (let other = 0; other < items.length; other += 1) {
            furthestRight = Math.max(
              furthestRight,
              loop.positions[other] + loop.widths[other]
            );
          }

          loop.positions[index] = furthestRight;
        }

        items[index].style.transform = `translate3d(${loop.positions[index]}px, 0, 0)`;
      }

      loop.frame = requestAnimationFrame(move);
    };

    measure();
    loop.frame = requestAnimationFrame(move);
  };

  const preloadCarouselSource = (source) => new Promise((resolve) => {
    const preload = new Image();
    preload.decoding = 'async';
    preload.addEventListener('load', resolve, { once: true });
    preload.addEventListener('error', resolve, { once: true });
    preload.src = source;

    if (preload.complete) resolve();
  });

  const prepareCampaignCarousel = (carousel) => {
    const images = [...carousel.querySelectorAll('.velv-campaign-carousel__image')];
    const sources = [...new Set(images.map((image) => image.currentSrc || image.src).filter(Boolean))];
    const updateLoopDistance = () => {
      setCampaignCarouselLoopDistance(carousel);
      carousel.classList.add('is-carousel-ready');
    };

    images.forEach((image) => {
      image.loading = 'eager';
      image.decoding = 'async';
      image.setAttribute('fetchpriority', 'high');
    });

    requestAnimationFrame(updateLoopDistance);
    window.setTimeout(updateLoopDistance, 250);

    Promise.all(sources.map(preloadCarouselSource)).then(async () => {
      await Promise.all(images.map((image) => image.decode ? image.decode().catch(() => {}) : Promise.resolve()));
      updateLoopDistance();
    });
  };

  campaignCarousels.forEach((carousel) => {
    prepareCampaignCarousel(carousel);
    startMobileCampaignLoop(carousel);
  });

  const syncCampaignCarousels = () => {
    campaignCarousels.forEach((carousel) => {
      setCampaignCarouselLoopDistance(carousel);
      startMobileCampaignLoop(carousel);
    });
  };

  window.addEventListener('resize', syncCampaignCarousels, { passive: true });
  mobileCarouselQuery.addEventListener('change', syncCampaignCarousels);

  const revealItems = document.querySelectorAll(
    '.forse-active__intro, .forse-active__product, .forse-manifest__line, .forse-archive__heading, .forse-archive__drop, .vel-products__heading, .vel-product, .vel-universe h2, .vel-archive__heading, .vel-archive__drop, .vel-archive-product, .velv-reveal, .newsletter'
  );

  if ('IntersectionObserver' in window) {
    revealItems.forEach((item) => item.classList.add('is-reveal-ready'));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );
    revealItems.forEach((item) => observer.observe(item));
  }

  document.querySelectorAll('.velv-hero-patch-reveal').forEach((item) => {
    const patchImages = item.querySelectorAll('.velv-hero-patch-reveal__img--patches');
    const hidePatches = () => {
      patchImages.forEach((image) => image.classList.remove('is-patch-visible'));
    };
    const showPatch = (patchId) => {
      hidePatches();
      const image = item.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
      if (image) image.classList.add('is-patch-visible');
    };

    item.querySelectorAll('[data-patch-hotspot]').forEach((hotspot) => {
      const patchId = hotspot.dataset.patchHotspot;

      hotspot.addEventListener('pointerenter', () => showPatch(patchId));
      hotspot.addEventListener('pointerleave', hidePatches);
      hotspot.addEventListener('focusin', () => showPatch(patchId));
      hotspot.addEventListener('focusout', hidePatches);
      hotspot.addEventListener(
        'touchstart',
        () => {
          const image = item.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
          const isVisible = image && image.classList.contains('is-patch-visible');
          hidePatches();
          if (!isVisible && image) image.classList.add('is-patch-visible');
        },
        { passive: true }
      );
    });
  });

  const hidePatchReveal = (container) => {
    if (!container) return;
    container.querySelectorAll('.velv-hero-patch-reveal__img--patches').forEach((image) => {
      image.classList.remove('is-patch-visible');
    });
  };

  const showPatchReveal = (hotspot) => {
    if (!hotspot) return;
    const container = hotspot.closest('.velv-hero-patch-reveal');
    const patchId = hotspot.dataset.patchHotspot;
    if (!container || !patchId) return;
    hidePatchReveal(container);
    const image = container.querySelector(`.velv-hero-patch-reveal__img--${patchId}`);
    if (image) image.classList.add('is-patch-visible');
  };

  document.addEventListener('pointerover', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('mouseover', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('click', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('pointerout', (event) => {
    const hotspot = event.target.closest('[data-patch-hotspot]');
    if (!hotspot) return;
    const container = hotspot.closest('.velv-hero-patch-reveal');
    if (container && event.relatedTarget && container.contains(event.relatedTarget)) return;
    hidePatchReveal(container);
  });

  document.addEventListener('focusin', (event) => {
    showPatchReveal(event.target.closest('[data-patch-hotspot]'));
  });

  document.addEventListener('focusout', (event) => {
    const hotspot = event.target.closest('[data-patch-hotspot]');
    if (hotspot) hidePatchReveal(hotspot.closest('.velv-hero-patch-reveal'));
  });

  const patchUpsell = document.querySelector('[data-patch-upsell]');
  const hoodieForms = document.querySelectorAll('[data-hoodie-form]');
  const archiveQuickAddForms = document.querySelectorAll('[data-archive-quick-add]');
  const archiveConfigurators = document.querySelectorAll('[data-archive-configurator]');
  const upsellCloseButtons = document.querySelectorAll('[data-patch-upsell-close]');
  const upsellForms = document.querySelectorAll('[data-upsell-form]');

  const setButtonState = (button, text, isDisabled) => {
    if (!button) return;
    button.textContent = text;
    button.disabled = isDisabled;
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((item) => {
        item.textContent = cart.item_count;
      });
    } catch (error) {
      // Cart count is non-critical; the line item has already been added.
    }
  };

  const openPatchUpsell = (selectedPatchTitle) => {
    if (!patchUpsell) return;
    const normalizedSelection = (selectedPatchTitle || '').trim().toLowerCase();
    const selectedPatchKey = normalizedSelection.includes('origin')
      ? 'origin'
      : normalizedSelection.includes('evolution')
        ? 'evolution'
        : normalizedSelection;
    let visibleCards = 0;

    patchUpsell.querySelectorAll('[data-upsell-card]').forEach((card) => {
      const cardTitle = (card.dataset.patchTitle || '').trim().toLowerCase();
      const cardPatchKey = cardTitle.includes('origin')
        ? 'origin'
        : cardTitle.includes('evolution')
          ? 'evolution'
          : cardTitle;
      const shouldHide = cardPatchKey === selectedPatchKey;
      card.classList.toggle('is-hidden', shouldHide);
      if (!shouldHide) visibleCards += 1;
    });

    patchUpsell.classList.toggle('has-one-upsell', visibleCards === 1);

    const copy = patchUpsell.querySelector('[data-patch-upsell-copy]');
    if (copy && selectedPatchTitle) {
      copy.textContent = `Has elegido ${selectedPatchTitle} gratis con la sudadera. Puedes sumar los otros packs al pedido antes de ir al carrito.`;
    }

    if (visibleCards === 0) {
      window.location.href = '/cart';
      return;
    }

    patchUpsell.classList.add('is-open');
    patchUpsell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-upsell-open');
  };

  const closePatchUpsell = () => {
    if (!patchUpsell) return;
    patchUpsell.classList.remove('is-open');
    patchUpsell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-upsell-open');
  };

  const closeArchiveConfigurator = (configurator) => {
    if (!configurator) return;
    const toggle = configurator.querySelector('[data-archive-configurator-toggle]');
    const panel = configurator.querySelector('[data-archive-configurator-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  };

  archiveConfigurators.forEach((configurator) => {
    const toggle = configurator.querySelector('[data-archive-configurator-toggle]');
    const panel = configurator.querySelector('[data-archive-configurator-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const willOpen = panel.hidden;
      archiveConfigurators.forEach((item) => {
        if (item !== configurator) closeArchiveConfigurator(item);
      });
      toggle.setAttribute('aria-expanded', String(willOpen));
      panel.hidden = !willOpen;
      if (willOpen) panel.querySelector('select')?.focus();
    });
  });

  document.addEventListener('click', (event) => {
    archiveConfigurators.forEach((configurator) => {
      if (!configurator.contains(event.target)) closeArchiveConfigurator(configurator);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    archiveConfigurators.forEach(closeArchiveConfigurator);
  });

  hoodieForms.forEach((hoodieForm) => {
    const variantData = hoodieForm.querySelector('[data-hoodie-variants]');
    const variantIdInput = hoodieForm.querySelector('[data-hoodie-variant-id]');
    const packProperty = hoodieForm.querySelector('[data-hoodie-pack-property]');
    const optionInputs = [...hoodieForm.querySelectorAll('[data-hoodie-option]')];
    let variants = [];

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const updateSelectedVariant = () => {
      if (!variants.length || !variantIdInput) return;
      const selectedOptions = optionInputs.map((input) => input.value);
      const selectedVariant = variants.find((variant) =>
        selectedOptions.every((value, index) => variant.options[index] === value)
      );
      const submitButton = hoodieForm.querySelector('button[type="submit"]');

      if (selectedVariant) {
        variantIdInput.value = selectedVariant.id;
        if (packProperty && selectedOptions[1]) packProperty.value = selectedOptions[1];
        if (submitButton) {
          submitButton.disabled = !selectedVariant.available;
          submitButton.textContent = selectedVariant.available ? 'Añadir sudadera' : 'Agotado';
        }
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateSelectedVariant));
    updateSelectedVariant();

    hoodieForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = hoodieForm.querySelector('button[type="submit"]');
      const selectedPatch = hoodieForm.querySelector('input[name="properties[Pack de parches gratis]"]:checked');
      const selectedPack = hoodieForm.querySelector('[data-hoodie-pack]');
      const selectedPatchTitle = selectedPatch ? selectedPatch.value : selectedPack ? selectedPack.value : '';
      const originalText = submitButton ? submitButton.textContent : '';
      const message = hoodieForm.querySelector('[data-hoodie-message]');

      setButtonState(submitButton, 'Añadiendo...', true);
      if (message) message.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(hoodieForm)
        });

        if (!response.ok) throw new Error('Cart add failed');

        await refreshCartCount();
        setButtonState(submitButton, 'Añadido', true);
        closeArchiveConfigurator(hoodieForm.closest('[data-archive-configurator]'));
        openPatchUpsell(selectedPatchTitle);
        window.setTimeout(() => setButtonState(submitButton, originalText, false), 900);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
        if (message) message.textContent = 'No se ha podido añadir. Inténtalo de nuevo.';
      }
    });
  });

  archiveQuickAddForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';
      setButtonState(submitButton, 'Añadiendo...', true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart add failed');
        await refreshCartCount();
        setButtonState(submitButton, 'Añadido', true);
        closeArchiveConfigurator(form.closest('[data-archive-configurator]'));
        window.setTimeout(() => setButtonState(submitButton, originalText, false), 900);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
      }
    });
  });

  upsellForms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton ? submitButton.textContent : '';

      setButtonState(submitButton, 'Anadiendo...', true);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('Cart add failed');

        await refreshCartCount();
        setButtonState(submitButton, 'Anadido', true);
      } catch (error) {
        setButtonState(submitButton, 'Reintentar', false);
      }
    });
  });

  upsellCloseButtons.forEach((button) => {
    button.addEventListener('click', closePatchUpsell);
  });

  if (patchUpsell) {
    patchUpsell.addEventListener('click', (event) => {
      if (event.target === patchUpsell) closePatchUpsell();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePatchUpsell();
    });
  }
});
